import { useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Radio, Row, Select, Typography } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { selectListTaskType } from '../../../store/slice/userSlice';
import './ReportsFilterDropdown.less';
import { setReportsFilter } from '../../../store/slice/reportsSlice';
import { CategoriasPunto } from '../../../utils/categorias_punto.constant';

interface DropDownFiltersProps {
  closeMenu: (isVisible: boolean) => void;
}

function ReportsFilterDropdown(props: DropDownFiltersProps) {
  const { Text } = Typography;
  const dispatch = useAppDispatch();
  const listTaskType = useAppSelector(selectListTaskType);
  const { RangePicker } = DatePicker;
  const [isDateRange, setIsDateRange] = useState(false);

  const filters = useAppSelector(state => state.reports.filtros);

  const closeMenuOnClick = () => {
    props.closeMenu(false);
  };

  const cleanFiltersOnClick = () => {
    dispatch(setReportsFilter({
      categorias: [],
      tipoTarea: [],
      fechaDesde: undefined,
      fechaHasta: undefined,
    }))
  };

  return (
    <div className={'ml-reports-drop-filter__container'}>
      <div className='ml-reports-drop-filter__order'>
        <Text className='label'>Fecha</Text>
        <div className='container'>
          <Radio.Group
            onChange={(event) => dispatch(setReportsFilter({ tipoFecha: event.target.value }))}
            value={filters.tipoFecha}
          >
            <Radio value={'realizacion'}>Fecha de realización</Radio>
            <Radio value={'cierre'}>Fecha de cierre</Radio>
          </Radio.Group>
          <div className='date-picker__container'>
            {isDateRange ? (
              <RangePicker
                size='large'
                placeholder={['Fecha inicial', 'Fecha límite']}
                className='range__date-picker'
                format={'DD/MM/YYYY'}
                allowClear={true}
                onChange={(values: any) => dispatch(setReportsFilter({
                  fechaDesde: values && values[0] ? values[0] : undefined,
                  fechaHasta: values && values[1] ? values[1] : undefined,
                }))}
                value={[filters.fechaDesde ?? null, filters.fechaHasta ?? null]}
              />
            ) : (
              <DatePicker
                className='date-picker'
                size='large'
                allowClear={true}
                placeholder='Elige una fecha'
                onChange={(date: any) => {
                  dispatch(setReportsFilter({ fechaDesde: date ?? undefined }))
                }}
                format={'DD/MM/YYYY'}
                value={filters.fechaDesde}
              />
            )}
            <Checkbox
              className='date-range__checkbox'
              onChange={e => setIsDateRange(e.target.checked)}
              checked={isDateRange}
            >
              Rango de fechas
            </Checkbox>
          </div>
        </div>
      </div>
      <div className='ml-reports-drop-filter__order'>
        <Text className='label'>Categoría</Text>
        <Select
          mode='multiple'
          placeholder={'Selecciona una categoría'}
          onChange={values => {
            dispatch(setReportsFilter({ categorias: [...values] }));
          }}
          value={filters.categorias}
          filterOption={(inputValue, option) =>
            option!.label
              ?.toString()
              .toLowerCase()
              .indexOf(inputValue.toLowerCase()) !== -1
          }
          options={CategoriasPunto.map(c => ({ label: c.label, value: c.id }))}
        />
      </div>
      <div className='ml-reports-drop-filter__order tipos-tareas-checkbox-group'>
        <Text className='label'>Tipo de Tarea</Text>{' '}
        <Checkbox.Group
          onChange={values => dispatch(setReportsFilter({ tipoTarea: values as number[] }))}
          value={filters.tipoTarea}
        >
          <Row>
            {listTaskType!.map((item) => (
              <Col span={12} key={item.id}>
                <Checkbox style={{marginBottom: 12}} value={item.id} key={item.id}>
                  {item.tipotarea}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </div>
      <div className='ml-reports-drop-filter__buttons'>
        <Button
          onClick={cleanFiltersOnClick}
          shape='round'
          className='clear__button'
        >
          Limpiar Filtros
        </Button>
        <Button type={'primary'} shape='round' onClick={closeMenuOnClick}>
          Aplicar
        </Button>
      </div>
    </div>
  );
}

export default ReportsFilterDropdown;
